import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetch_adoption_details, save_adoption_details } from './api';
import type { AdoptionDetailsRequest } from './types';

const KEY = ['module-details', 'adoption'] as const;

export function use_save_adoption_details() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: AdoptionDetailsRequest) => save_adoption_details(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['onboarding', 'draft'] });
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function use_adoption_details(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: KEY,
    queryFn: fetch_adoption_details,
    staleTime: 0,
    retry: 0,
    enabled: options?.enabled ?? true,
  });
}
